import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { useEffect, useState } from "react";
import {BASE_API_URL as baseURL} from ".././Constant"
import "./Analytics.css";

// const baseURL = "https://atcgn.lkm.accenture.com/atcgn-api";
//const baseURL = "http://localhost:1111";

function Analytics() {
  // const [totalViews, setTotalViews] = useState(0);
  // const [totalUserViews, setTotalUserViews] = useState(0);
  const [data, setData] = useState([]);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  let loggedInEnterpriseId = "";
  let Userlocation
  if (activeAccount)
    loggedInEnterpriseId = activeAccount.idTokenClaims.enterpriseID;
    Userlocation = activeAccount.idTokenClaims.location

  const lkmPagesAnalytics = () => {
    axios
      .post(
        `${baseURL}/analytics`,
        {
          enterprise_id: loggedInEnterpriseId,
          location: Userlocation
        },
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        getAnalytics();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getAnalytics = () => {
    axios
      .get(`${baseURL}/analytics`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data);
        // setTotalViews(response.data.totalViews);
        // setTotalUserViews(response.data.totalUniqueUsers);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const totalUserViews =
    data != undefined &&
    data != null &&
    data.map((view) => view.totalUniqueUsers);

  const totalViews =
    data != undefined &&
    data != null &&
    data.map((view) => view.Data[0].totalSum);

  useEffect(() => {
    if (!loggedInEnterpriseId) {
      console.error("Enterprise ID is missing. Not calling analytics API.");
      return;
    }
    lkmPagesAnalytics();
  }, [loggedInEnterpriseId]);

  return (
    <>
      {/* {process.env.NODE_ENV === "production" && ( */}
      <span className="analytics-span">
        <img
          src={process.env.PUBLIC_URL + "/images/Home/medium-eye.png"}
          className="eye-icon"
          alt="eye"
        />{" "}
        Total Views: {totalViews} &nbsp; | &nbsp; Unique Views: {totalUserViews}
      </span>
      {/* )} */}
    </>
  );
}

export default Analytics;
